module.exports = __webpack_public_path__ + "static/media/shopping-bag.61aa5260.svg";